import { useEffect } from 'react'
import {
	useFeatureFlag,
	useFeatureFlagsStatus
} from 'services/feature-flags'
import { setDarkModeAllowed } from 'utils/theme'

/**
 * Gates dark mode behind the 'dark_mode_enabled' PostHog flag.
 * Once flags are ready the value is synced into utils/theme, where the stored
 * preference defaults to 'light' while the flag is off (without wiping the
 * saved choice). Returns whether dark mode is enabled — drives the navbar
 * theme switcher's visibility.
 */
export const useDarkModeFlag = (): boolean => {
	const enabled = useFeatureFlag('dark_mode_enabled')
	const { flagsReady } = useFeatureFlagsStatus()

	useEffect(() => {
		if (flagsReady) setDarkModeAllowed(enabled)
	}, [flagsReady, enabled])

	return enabled
}
